<template>
  <a-row type="flex" justify="center" style="height: 5vh">
    <a-col class="team_index_bar_item">
      <router-link to="/team_m/partner">
        <div class="bar_item" tabindex="1">投资合伙人</div>
      </router-link>
    </a-col>
    <a-col class="team_index_bar_item">
      <router-link to="/team_m/manager_adviser">
        <div class="bar_item" tabindex="2">投资经理及顾问</div>
      </router-link>
    </a-col>
    <a-col class="team_index_bar_item">
      <router-link to="/team_m/post_investment_operation">
        <div class="bar_item" tabindex="3">投后及运营团队</div>
      </router-link>
    </a-col>
  </a-row>
</template>

<script>

export default {
  name: 'Team_index_bar_m',
}
</script>

<style scoped>
.team_index_bar_item {
  background: grey;
  line-height: 5vh;
  margin: 0.1vw;
  width: 33vw;
}

.bar_item {
  color: white;
}

.bar_item:focus {
  background-color: #2f54eb;
}

</style>